module.exports = __webpack_public_path__ + "img/frich_Kritikk_av_ideologi_og_menneskesyn1.85fe6143.jpg";